const SDK_VERSION = "10.71.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
